import styled from 'styled-components';

const Input = styled.input`
  background: transparent;
  border: none;

  padding: 0;
  font-size: 13px;
  width: 100%;
  font-family: var(--font-family-body);
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: -0.02em;

  color: var(--content-body);

  caret-color: var(--primary-default);

  transition: background 500ms linear;

  resize: vertical;

  ::placeholder {
    font-family: var(--font-family-body);
    color: var(--content-subtitle);
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: -0.02em;
    transition: opacity 0.5s 0.5s ease, text-indent 0.5s 0.25s ease;

    opacity: 1;
    text-indent: 0;
  }

  &:focus {
    outline: none;

    &::placeholder {
      opacity: 0;
      text-indent: -100%;
    }
  }

  @media (max-width: 768px) {
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
    }
  }
`;

export { Input };
